import '../../../css/cssLoader';
import React, { useContext, useEffect } from 'react';
import DashboardUser from '../../User/Dashboard/DashboardUser';
import DashboardExpert from '../../Expert/Dashboard/DahsboardExpert';
import { ProfileContext } from '../../Contexts/contexts';
import useAuth from '../../Contexts/useAuth';
import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import { userRole } from '../../../data/roleData';

function Dashboard() {
	const contextData = useContext(ProfileContext);
	const { checkAuth } = useAuth();

	useEffect(() => {
		checkAuth();
	}, [checkAuth]);

	return (
		<>
			{contextData.isClient && <DashboardUser />}
			{contextData.isExpert && <DashboardExpert />}
			{contextData.role === userRole.UNDEFINED && <HeaderMinimal />}
		</>
	);
}

export default Dashboard;
